module.exports = __webpack_public_path__ + "img/box-deskit.50699c9f.png";